import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {LoadingComponent} from 'recupero-comunes'
import { Card, Container } from 'react-bootstrap'
import BuscarCasos from './buscar-casos'
// import BandejaCasos from './bande-casos'
import { Auth } from 'recupero-comunes'
import { configuracionFormAction, obtenerCriteriosFechaAction, obtenerEstadosCasoAction, obtenerInstanciaJudicial, obtenerRangoFechas, obtenerTareasAction,
   obtenerTareasUsuarioAction, obtenerTipoGestionAction, obtenerComboCompetencia } from '../../store/actions/encargado-recupero-action'
import BandejaCasos from './bandeja-casos'

const RecuperoDirecto = () => {
    const [loading, setLoading]=useState(false)
    const { rutUsuario, rutOrganizacion } = Auth.currentUser()
    const dispatch = useDispatch()
    const data_encargado_recupero = useSelector(
        (state) => state.encargado_recupero
      )
      const {
        cfg_form,
        
      } = data_encargado_recupero

    useEffect(() => {
      setLoading(true)
        let query = Buffer.from(
            JSON.stringify({ idform: 6, rutcia: rutOrganizacion })
          ).toString('base64')
          dispatch(configuracionFormAction(query))
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, parametro: 1 })
              ).toString('base64')
              dispatch(obtenerRangoFechas(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 207 })
              ).toString('base64')
              dispatch(obtenerTipoGestionAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 213 })
              ).toString('base64')
              dispatch(obtenerEstadosCasoAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ tipoGestion: null, ambitoGestion: null, idSituacion: null, idModoIngreso: 238006 })
              ).toString('base64')
              dispatch(obtenerInstanciaJudicial(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, concepto: 29 })
              ).toString('base64')
              dispatch(obtenerCriteriosFechaAction(query))
         })
         .then(()=>{
            let query = Buffer.from(JSON.stringify({ "concepto":240})).toString('base64')
            dispatch(obtenerComboCompetencia(query))
          })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({ rutcia: rutOrganizacion, rutusr: rutUsuario, flujo: 3, flujo1: 4 })
              ).toString('base64')
              dispatch(obtenerTareasUsuarioAction(query))
         })
         .then(()=>{
            let query = Buffer.from(
                JSON.stringify({
                  rutcia: rutOrganizacion,
                  rutusr: rutUsuario,
                  flujo: 3, flujo1: 4,
                  todos: document.getElementById('todos')
                    ? document.getElementById('todos').checked
                    : false
                })
              ).toString('base64')
              dispatch(obtenerTareasAction(query))
         })
        .then(()=>setLoading(false))
        
     }, [dispatch])
    
   
    
    
    return (
        <div> 
             <LoadingComponent show={loading}/>
             <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
                  {cfg_form &&  `${cfg_form['bandejatareasabo-title']}`}</Card.Header>
                <Card.Body>
                        <BuscarCasos  />
                        <BandejaCasos  />
                  
             </Card.Body>
            </Card>
            </Container> 
        </div>
    )
}

export default RecuperoDirecto
